const common = require('./en/common');
const statistics = require('./en/statistics');
module.exports = {

    login:{
        login:"登錄",
        username:"账号",
        password:"密码",
        title: "Fosber  Asia",
        subTitle: "欢迎使用 FOSBER ASIA 管理后台",
        loginName: "用戶名",
        submit: "登录",
        rulesName: "用戶名为空",
        rulesPassword: "密码为空",
        remember: "记住我",
        success: "成功",
    },


    awaitDaily_dailyList:{
        "部门":"部门",
        "提交人":"提交人",
        "日报日期":"日报日期",
        "状态":"状态",
        "备注":"备注",

        '日期':"日期",
        '年':'年',
        '月':'月',
        '日':'日',
        '最近7天未提交日报':'（最近7天）未提交日报：',
        '最近7天':'（最近7天）',
        '未提交日报':'未提交日报：',
        '至':'至',
        '开始日期':'开始日期',
        '结束日期':'结束日期',
        '请选择':'请选择',
        '成员':'成员',
        '搜索':'搜索',
        '关闭':'关闭',
        '退回':"退回",
        '待审核':'待审核',
        '已审核':'已审核',
        '修改备注':'修改备注',
        '已关闭':'已关闭',
        '审核通过':'审核通过',
        '未提交':'未提交',
        '关闭日报':'关闭日报',
        '请确认是否关闭此日报':'请确认是否关闭此日报',
        '关闭之后该员工将无法填写日期日报':'关闭之后，该员工将无法填写日期日报',
        '提交':'提交',
        '取消':'取消',
        '所在部门':'所在部门',
        '汇报人':'汇报人',
        '请输入关闭的原因说明比如：休假等':'请输入关闭的原因说明（比如：休假等）.....',
        '请先输入备注':'请先输入备注',
        '操作成功':'操作成功',

    },

    awaitDaily_myDailyList:{
        '日期':'日期',
        '年':'年',
        '月':'月',
        '日':'日',
        '最近7天个人未提交日报':'（最近7天）个人未提交日报',
        '超过7天日报不支持提交':'*超过7天日报不支持提交',
        '全部':'全部',
        '最近7天未提交':"（最近7天）未提交",
        '待审核':"待审核",
        '已审核':"已审核",
        '已关闭':"已关闭",
        '写日报':"写日报",

        "部门":"部门",
        "提交人":"提交人",
        "日报日期":"日报日期",
        "状态":"状态",
        "备注":"备注",
    },

    awaitDaily_editMyDaily:{
        '提交人':'提交人',
        '日报日期':'日报日期',
        '状态':'状态',
        '部门':'部门',
        '确定':'确定',
        '取消':'取消',
        '日报内容':'日报内容',
        '添加内容':'添加内容',
        '其余事项':'其余事项',
        '添加事项':'添加事项',
        '删除事项':'删除事项',
        '内容':'内容',
        '阶段内容':'阶段内容',
        '修改工序':'修改工序',
        '删除工序':'删除工序',
        '实际工时':'实际工时',
        '时间段':'时间段',
        // '技术改造':'技术改造',
        // '服务支持':'服务支持',
        '小时':'小时',
        '修改事项':'修改事项',
        '提交':'提交',
        '点击编辑修改':'点击编辑修改',
        '提交日报':'提交日报',
        '项目':'项目',
        '单元':'单元'
    },
     //------->车间3.0文案
    workShop:{
        '阶段详情':'阶段详情',
        '工序详情':'工序详情',
        '新增工序':'新增工序',
        '批量新增':'批量新增',
        '批量新增工序':'批量新增工序',
        '阶段':'阶段',
        '阶段类型':'阶段类型',
        '请选择阶段类型':'请选择阶段类型',
        '阶段编号':'阶段编号',
        '工序数量':'工序数量',
        '请选择':'请选择',
        '不能为空':'不能为空',
        '工序':'工序',
        '标准工时':'标准工时',
        '上限工时':'上限工时',
        '实际工时':'实际工时',
        '剩余工时':'剩余工时',
        '阶段实际工时':'阶段实际工时',
        '报工上限工时':'报工上限工时',
        '日报总实际工时':'日报总实际工时',
        '增加新工序':'增加新工序',
        '移除工序':'移除工序',
        '工序标准时间上限时间不可为空':"工序、标准时间、上限时间不可为空",
        '新增成功':'新增成功',
        '删除成功':'删除成功',
        '关闭成功':'关闭成功',
        '编辑成功':'编辑成功',
        '查看修改':'查看修改',
        '上传成功':'上传成功',
        '上传失败请到上传记录下载错误文件':'上传失败，请到上传记录下载错误文件',
        '错误信息记录':'错误信息记录',
        '请输入工时大于0':'请输入工时大于0',
        '上限工时不能小于实际工时':'上限工时不能小于实际工时',
        '上限工时不能小于标准工时':'上限工时不能小于标准工时',
        '详细工序':'详细工序',
        '小时':'小时',
        '分钟':'分钟',
        '班级员工日报':'班级员工日报',
        '关闭阶段':'关闭阶段',
        '阶段数':'阶段数',
        '审核日报':'审核日报',
        '审核人':'审核人',
        '审核成功':'审核成功',
        '请选择机械部门':'请选择机械部门',
        '请选择电气部门':'请选择电气部门',
        '请选择调试部门':'请选择调试部门',
        '请输入工时大于等于0':'请输入工时大于等于0'

    },
    // 通用翻译
    common: common,
    statistics,
}